module.exports = __webpack_public_path__ + "static/on-liberty-343491c8046890de80a62331fff9855f.jpg";